import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the customIndicators state domain
 */

const selectSynchronizationErrorsDomain = (state) =>
  state.get("synchronizationErrors", initialState)

/**
 * Other specific selectors
 */

/**
 * Default selector used by CustomIndicators
 */

const makeSelectSynchronizationErrors = () =>
  createSelector(selectSynchronizationErrorsDomain, (substate) => substate.toJS())

export const makeSelectIsLoadingSynchronizationErrors = () =>
  createSelector(selectSynchronizationErrorsDomain, (state) =>
    state.get("isLoadingSynchronizationErrors")
  )

export const makeSelectSynchronizationErrorsList = () =>
  createSelector(selectSynchronizationErrorsDomain, (state) =>
    state.get("synchronizationErrors")
  )

export default makeSelectSynchronizationErrors
export { selectSynchronizationErrorsDomain }
